module.exports = __webpack_public_path__ + "static/media/marcel_ionescu_heroiu.cf26cb64.png";